import { render, staticRenderFns } from "./Edit-Teacher.vue?vue&type=template&id=d4af61a4&scoped=true"
import script from "./Edit-Teacher.vue?vue&type=script&lang=js"
export * from "./Edit-Teacher.vue?vue&type=script&lang=js"
import style0 from "./Edit-Teacher.vue?vue&type=style&index=0&id=d4af61a4&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4af61a4",
  null
  
)

export default component.exports